import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import backarrow from "../../../../components/Images/backarrow.svg";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../../src/layout/Others/Response_Loading_processing";
import deleteitem from "../../../../components/Images/deleteitem.svg";
import "./Manage_Geo_Fencing.css";
import { Table } from "react-bootstrap";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import { CiShare1 } from "react-icons/ci";

function Manage_Geo_Fencing(props) {
  const [editUser, setEditUser] = useState({
    id: "",
    geofencing: "",
    available_countries_status: "",
    createdAt: "",
    updatedAt: "",
    ipAddress: "",
    countryName: "",
    regionName: "",
    cityName: "",
    currentTimeZone: "",
    countryId: "",
    geoip_source: "",
    geoip_token: "",
  });
  const [defaultOption, setDefaultOption] = useState("");
  const [serverTime, setServerTime] = useState("");
  const [geoFetchingTime, setGeoFetchingTime] = useState("");
  const [serverTimezone, setServerTimezone] = useState("");

  console.log(editUser, "dafdsf")
  const access_token = localStorage.getItem("access_token");

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  // console.log(headers)
  const fetchGeoSettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/setting/geo-fencing`,
        { headers: headers }
      );
      console.log(response, "responseresponse")
      const geoSettings = response?.data?.geo_settings;
      const option = response?.data?.geoip_source;
      setServerTime(response?.data?.server_time);
      setGeoFetchingTime(response?.data?.geo_fetching_time);
      setServerTimezone(response?.data?.server_timezone);

      const locationInfo = response?.data?.location_info;
      setDefaultOption(option);
      if (locationInfo) {
        const mergedData = {
          ...(geoSettings || {}),
          ...locationInfo,
        };
        setEditUser(mergedData);
      }

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {


    fetchGeoSettings();
  }, []);


  const handleInput = (e) => {
    // console.log(e.target.checked, e.target.value);
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
    } else {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
    }
  };
  const handleInputonoff = (e) => {
    // console.log(e.target.checked, e.target.value);
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: "ON" });
    } else {
      setEditUser({ ...editUser, [e.target.name]: "OFF" });
    }
  };
  const handleInputstatus = (e) => {
    // console.log(e.target.checked, e.target.value);
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    // const editInputvalue = {
    //   id: editUser?.id,
    //   geofencing: editUser?.geofencing,
    //   geofencing_status: editUser?.geofencing_status,
    // };
    const editInputvalue = {
      id: editUser?.id,
      geofencing_status: editUser?.geofencing,
      available_countries_status: editUser?.available_countries_status,
      geoip_source: editUser?.geoip_source,
      geoip_token: editUser?.geoip_token,
    };


    setProcessing(true);
    setShowOverlay(true);

    let res = await fetch(
      `${process.env.REACT_APP_Baseurl}/admin/setting/geo-fencing`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(editInputvalue),
      }
    );
    let resjson = await res?.json();

    if (resjson?.status === true) {
      var resultapi = resjson;

      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resjson?.status === false) {
        var resultError = resjson;
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const editInputvalue = {
  //     id: editUser.id,
  //     geofencing: editUser.geofencing,
  //     geofencing_status: editUser.geofencing_status,
  //   };
  //   // console.log(editInputvalue);
  //   let res = await fetch(
  //     `${process.env.REACT_APP_Baseurl}/admin/Geo-fencing/update`,
  //     {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(editInputvalue),
  //     }
  //   );

  //   let resjson = await res.json();
  //   // console.log(resjson)
  //   if (res.status === 200) {
  //     setMessage(resjson.success);
  //     alert('Success')
  //     // window.location.reload();
  //     setTimeout(() => {}, 2000);
  //   } else {
  //     setMessage("Some error Occured");
  //     console.log("Error");
  //     alert("Enter Correct Details");
  //   }
  // };

  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const handleToggle = (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  // const confirmToggle = async () => {
  //   try {
  //     setShowModal(false);
  //     // const newStatus = editUser?.geofencing_status === 1 ? 0 : 1;
  //     const newStatus = Number(editUser?.geofencing) === 1 ? 0 : 1;

  //     const response = await fetch(
  //       `${process.env.REACT_APP_Baseurl}/admin/setting/geo-fencing`,
  //       {
  //         method: "POST",
  //         body: JSON.stringify({
  //           id: currentItem?.id,
  //           geofencing: newStatus,
  //           geofencing_status: newStatus,
  //         }),
  //         headers: headers,
  //       }
  //     );

  //     const responseData = await response.json();

  //     if (response.ok) {
  //       setEditUser({ ...editUser, geofencing_status: newStatus }); // Update the local state
  //       props?.setApiresponsealert(responseData);
  //       props?.setShowalert(true);
  //       // setMessage(responseData.message);        
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 3000);
  //     } else {
  //       props?.setApiresponsealert(responseData);
  //       props?.setShowalert(true);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const closeModalslider = () => {
    setShowModal(false);
    setCurrentItem(null);
  };

  const [addCountryselect, setAddCountryselect] = useState();
  const [countriesdrop, setCountriesdrop] = useState([]);
  const [datacountry, setDatacountry] = useState([]);
  const [countcountry, setCountcountry] = useState();
  const [pagecountry, setPagecountry] = useState(1);
  const [countrydatacountry, setVideodatacountry] = useState("");
  const [loading, setLoading] = useState(true);
  const [defaultImage, setDefaultimage] = useState();
  const [defaultImageurl, setDefaultimageurl] = useState("");
  const [currentPagecountry, setCurrentPagecountry] = useState(1);
  const itemsPerPagecountry = 10;

  const deleteOperationcountry = (id) => {
    const access_token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    };
    axios
      .delete(
        `${process.env.REACT_APP_Baseurl}/admin/Block-countries/delete/` + id,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response?.data?.status == true) {
          var responseData = response?.data;
          props?.setApiresponsealert(responseData);
          props?.setShowalert(true);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          if (responseData === false) {
            var resultError = responseData;
            props?.setApiresponsealert(resultError);
            props?.setShowalert(true);
          }
        }
      });
  };

  const [selectedItemscountry, setSelectedItemscountry] = useState([]);
  const [selectAllcountry, setSelectAllcountry] = useState(false);
  const [isConfirmationOpencountry, setIsConfirmationOpencountry] =
    useState(false);
  const [isSuccessMessageOpencountry, setIsSuccessMessageOpencountry] =
    useState(false);

  const handleSingleSelectcountry = (itemId) => {
    setSelectedItemscountry([itemId]);
    setSelectAllcountry(false);
  };

  const handleMultiSelectcountry = (itemId) => {
    if (selectedItemscountry?.includes(itemId)) {
      setSelectedItemscountry(
        selectedItemscountry?.filter((id) => id !== itemId)
      );
    } else {
      setSelectedItemscountry([...selectedItemscountry, itemId]);
    }
  };

  const handleSelectAllcountry = () => {
    setSelectAllcountry(!selectAllcountry);
    setSelectedItemscountry(
      selectAllcountry ? [] : countrydatacountry?.map((item) => item?.id)
    );
  };

  const handleDeletecountry = () => {
    setIsConfirmationOpencountry(true);
  };
  const handleCancelDeletecountry = () => {
    setIsConfirmationOpencountry(false);
  };

  const handleConfirmDeletecountry = () => {
    setIsConfirmationOpencountry(false);
    for (const itemId of selectedItemscountry) {
      axios
        .delete(
          `${process.env.REACT_APP_Baseurl}/admin/Block-countries/delete/${itemId}`,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.status == true) {
            setVideodatacountry(
              countrydatacountry?.filter((item) => item?.id !== itemId)
            );
            setSelectedItemscountry(
              selectedItemscountry?.filter((id) => id !== itemId)
            );
            setIsSuccessMessageOpencountry(true);
            setTimeout(() => {
              setIsSuccessMessageOpencountry(false);
            }, 2000);
            var responseData = response.data;
            props?.setApiresponsealert(responseData);
            props?.setShowalert(true);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            if (responseData === false) {
              var resultError = responseData;
              props?.setApiresponsealert(resultError);
              props?.setShowalert(true);
            }
          }
        });
    }
  };

  const fetchDatanextprecountry = () => {
    axios
      .get(
        `${process.env.REACT_APP_Baseurl}/admin/Block-countries/index`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        const countryData = res?.data?.countries;

        setCountcountry(res?.data?.total_count);

        setVideodatacountry(countryData);
        if (countryData?.length > 0) {
          setDatacountry(countryData);
          setLoading(false);
        } else {
          setDatacountry([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchDatanextprecountryselect = () => {
    axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Block-countries/create?page=1&limit=253`, {
        headers: headers,
      })
      .then((response) => {
        var result = response?.data?.countries;
        setCountriesdrop(result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // const fetchDatacountry = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_Baseurl}/admin/Block-countries/index`,
  //       { headers: headers }
  //     );
  //     setCountcountry(response?.data?.total_count);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoading(false);
  //   }
  // };

  const indexOfLastItemcountry = currentPagecountry * itemsPerPagecountry;
  const indexOfFirstItemcountry = indexOfLastItemcountry - itemsPerPagecountry;
  const currentItemscountry = datacountry?.slice(
    indexOfFirstItemcountry,
    indexOfLastItemcountry
  );

  const handlePreClickcountry = () => {
    if (pagecountry > 1) {
      setPagecountry(pagecountry - 1);
    }
  };

  const handleNxtClickcountry = () => {
    setPagecountry(pagecountry + 1);
  };

  const [itemToDeletecountry, setItemToDeletecountry] = useState(null);
  const [successMessagecountry, setSuccessMessagecountry] = useState("");

  const openModalcountry = (id) => {
    setItemToDeletecountry(id);
    setSuccessMessagecountry("");
  };

  const closeModalcountry = () => {
    setItemToDeletecountry(null);
  };
  const handleDeletedata = () => {
    closeModalcountry();
    if (itemToDeletecountry) {
      deleteOperationcountry(itemToDeletecountry);
    }
  };
  useEffect(() => {
    // fetchDatacountry();
    fetchDatanextprecountry();
    fetchDatanextprecountryselect();
  }, [pagecountry]);
  const [editUsercountry, setEditUsercountry] = useState({
    country: "",
  });

  const handleInputcountry = (e) => {
    const { name, value } = e.target;
    setEditUsercountry((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagecountry("");
    setIsValidationHiddencountry(true);

    setEditUsercountry({ ...editUsercountry, [e.target.name]: e.target.value });
  };

  const [validationMessagecountry, setValidationMessagecountry] = useState("");
  const [isValidationHiddencountry, setIsValidationHiddencountry] =
    useState(true);

  const countryInputRef = useRef(null);

  async function addcountries() {
    let focusInputRef = null;

    if (editUsercountry?.country === "") {
      setValidationMessagecountry("Country cannot be empty.");
      setIsValidationHiddencountry(false);
      focusInputRef = countryInputRef;
    }

    // const formData = new FormData();

    // formData.append("id", editUsercountry?.country);
    const formData = {
      id: editUsercountry?.country
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    let firstApiStatus = false;
    let resultapi = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Block-countries/store`,
        formData,
        { headers: headers }
      );

      if (response?.data?.status === true) {
        firstApiStatus = true;

        resultapi = response?.data;
      }
    } catch (error) { }

    if (firstApiStatus) {
      setValidationMessagecountry("");
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resultapi === false) {
        setProcessing(false);
        setShowOverlay(false);
        var resultError = resultapi;
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setIsValidationHiddencountry(false);
      }
    }
  }

  return (
    <>
      <div className="banner-slider">
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            {/* <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Slider </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModalslider}
                  ></button>
                </div>
                <div className="modal-body">
                  Are you sure you want to Switch the Geo-Fencing Status?
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModalslider}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={confirmToggle}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        )}
      </div>

      <div
        className="modal fade"
        id="deleteexampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog delete_confirm">
          <div className="modal-content text-center">
            <div className="modal-body">
              {isConfirmationOpencountry && (
                <div>
                  <h5 className="modal-title p-3" id="exampleModalLabel">
                    <p className="fs-6">
                      Are you sure you want to delete the selected items?
                    </p>
                  </h5>
                  <div className="col-lg-12 row p-4">
                    <div className="col-lg-6">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          handleConfirmDeletecountry();
                        }}
                      >
                        Confirm
                      </button>
                    </div>
                    <div className="col-lg-6">
                      <button
                        className="btn btn-primary"
                        onClick={handleCancelDeletecountry}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {isSuccessMessageOpencountry && (
                <div className="success-message">
                  <div className="p-5">
                    <i className="fa fa-check" aria-hidden="true"></i>
                  </div>
                  <p className="fs-6 fw-bold">
                    Selected items have been successfully deleted.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <AdminBackNavigation path="/settings" text="Back" />
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Geo-Fencing Settings"} saveText={"Update"} saveMethod={handleUpdate} />

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={"Geo Details"} />
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"IP Address"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.ipAddress ? editUser.ipAddress : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Country Name"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.countryName ? editUser.countryName : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Region Name"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.regionName ? editUser.regionName : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"City Name"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.cityName ? editUser.cityName : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Current TimeZone"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.currentTimeZone ? editUser.currentTimeZone : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Country Id"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {editUser?.countryId ? editUser.countryId : '-'}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Server Time"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {serverTime || '-'} {serverTimezone ? `(${serverTimezone})` : ''}
                </p>
              </div>
            </div>
            <div className="col-lg-12 d-flex align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-5">
                <MessageLabel text={"Geo Fetching Time"} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  :
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5">
                <p className="p2 theme-text-color mb-3 mt-0 d-block position-relative">
                  {geoFetchingTime || '-'} {editUser?.currentTimeZone ? `(${editUser.currentTimeZone})` : ''}
                </p>
              </div>
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Geo Fencing Settings"} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Block Country Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name="geofencing" value={editUser?.geofencing} checked={editUser?.geofencing == "ON"} onChange={handleInputonoff} id={editUser?.geofencing} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={" Avaliable Country Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name="available_countries_status" value={editUser?.available_countries_status} checked={editUser?.available_countries_status == 1} onChange={handleInputstatus} id={editUser?.available_countries_status} />
              </div>
            </div>
          </Wrapper>
          <Wrapper>
            <MessageHeading text={"Geo Fencing Token"} />
            <div className="d-flex mb-2 mt-0 theme-text-color opacity-75 admin-input-description">
              <p className="me-2">Generate a API token for access</p>
              <Link
                className="custom-link d-flex align-items-center"
                target="_blank"
                to="https://ipinfo.io/dashboard/token"
              >
                <span>Visit</span>
                <CiShare1
                  style={{
                    width: "15px",
                    height: "15px",
                    strokeWidth: "1px",
                    marginLeft: "6px",
                  }}
                />
              </Link>
            </div>

            <AdminCustomSelect
              name="geoip_source"
              value={editUser?.geoip_source || ""}
              onChange={handleInput}
              options={[
                { name: "Select", value: "" }, // Default null option
                ...(defaultOption?.length ? defaultOption.map(item => ({
                  name: item?.name,
                  value: item?.value
                })) : [])
              ]}
            />
            <AdminCustomInput type="text" name="geoip_token" value={editUser?.geoip_token} onChange={handleInput} placeHolder={"Enter Geo Fencing Token"} />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default Manage_Geo_Fencing;
